import React, { useState, useMemo } from 'react'
import { Form, Button, Icon } from 'semantic-ui-react'
import request from 'services/http'
import { toast } from 'react-toastify'
import { tap, finalize } from 'rxjs/operators'
import InputMask from 'react-input-mask'
import { useSubscription } from 'utils'

export default function ConferirForm({ empresas, periodos, form, dispatch, setApuracao }) {

    const [isSubmitting, setIsSubmitting] = useState(false)

    function handleChange(event, props) {
        let name, value
        if (!props)
           [name, value] = [event.target.name, event.target.value]
        else {
            name = props.name
            value = props.value
        }
        if (name === 'splitByMonth')
            value = props.checked
        dispatch({ type: 'setForm', payload: { [name]: value } })
    }

    function handleSubmit(event) {
        if (!(!!form.empresa) || (form.periodType === 1 && !(!!form.periodo)) || (form.periodType === 2 && (!(!!form.dataIni) || !(!!form.dataFim)) ))
            toast.error('Há campos não preenchidos.')
        else {
            event.currentTarget.querySelector('button').blur()
            setIsSubmitting(true)
        }   
    }

    const submitForm$ = useMemo(() => request({ url: '/dre/apuracao-icms', method: "POST", body: form }).pipe(
        tap(({ response }) => setApuracao(response.periodo)),
        finalize(() => setIsSubmitting(false))
    ), [form, setApuracao])

    useSubscription(submitForm$, isSubmitting)

    return (
        <Form size='mini' className="w-75" loading={isSubmitting} onSubmit={handleSubmit} noValidate>
            <div className="row">
                <div className="col col-md-8 offset-md-2">
                    <Form.Select search noResultsMessage='Nenhum resultado encontrado' required label='Empresa' placeholder='Selecionar empresa' name='empresa' value={form.empresa} onChange={handleChange} options={empresas ? empresas.filter(x => x.ativo === 1 && ['POSTO', 'CENTRAL'].includes(x.tipo)).map(x => Object.assign({}, { text: x.codDpnet + ' - ' + x.nomeEmpresa, value: x._id })) : []}/>
                </div>
            </div>
            <div className="row mt-2">
                <div className="col col-md-8 offset-md-2">
                    <Form.Select required label='Pesquisar por' name='periodType' value={form.periodType} onChange={handleChange} options={[{ text: 'Trimestres', value: 1 }, { text: 'Datas', value: 2 }]} />
                </div>
            </div>
            {form.periodType === 1 && <><div className="row mt-2">
                <div className="col col-md-8 offset-md-2">
                    <Form.Select required label='Periodo' placeholder='Selecione o trimestre' name='periodo' value={form.periodo} onChange={handleChange} options={periodos ? periodos.map(x => Object.assign({}, { text: x.descricao, value: x.id })) : []} />
                </div>
            </div>
            <div className="row mt-2">
                <div className="col col-md-8 offset-md-2">
                    <Form.Checkbox label='Separar por mês' name='splitByMonth' onChange={handleChange} />
                </div>
            </div></>}
            {form.periodType === 2 && <>
                <div className='row mt-2'>
                    <div className="col col-md-4 offset-md-2">
                        <InputMask mask='99/99/9999' name='dataIni' value={form.dataIni} onChange={handleChange} >
                            {inputProps => <Form.Input {...inputProps} required={form.periodType === 2} label='Data Inicial'  placeholder='Informar data inicial' />}
                        </InputMask> 
                    </div>
                    <div className="col col-md-4">
                        <InputMask mask='99/99/9999' name='dataFim' value={form.dataFim} onChange={handleChange} >
                            {inputProps => <Form.Input {...inputProps} required={form.periodType === 2} label='Data Final'  placeholder='Informar data final' />}
                        </InputMask> 
                    </div>
                </div>
            </>}
            <div className="row pt-4 text-center">
                <div className="col">
                    <Button className='w-25' color='green' size='tiny' animated='fade' >
                        <Button.Content visible>{isSubmitting ? 'Carregando...' : 'Buscar' }</Button.Content>
                        <Button.Content hidden><Icon name='search' /></Button.Content>
                    </Button>
                </div>
            </div>
        </Form>
    )
}
